import { api } from "@/builders/axios";

const get = function (id: number) {
  return api.get<{
    option: string;
    is_answer: boolean;
  }>(`questions/question-option/${id}`);
};

const del = function (id: number) {
  return api.delete(`questions/question-option/${id}`);
};

export const id = {
  get,
  del,
};
